var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlasFargat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 40,
    viewBox: "0 0 14 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2371_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1254 15.1705C11.9454 14.7135 10.2975 8.75195 10.0067 7.67873C9.93396 7.41215 9.88203 6.37009 9.8578 5.30725V5.11338C9.85087 4.9749 9.85087 4.83642 9.84741 4.7014C9.97551 4.41406 10.0413 4.11286 10.0413 3.80474C10.0413 3.44816 9.94781 3.1158 9.87165 2.84923C9.83703 2.73152 9.78856 2.55496 9.78856 2.49611V2.26761C9.88549 2.11528 9.95473 1.94218 9.97551 1.73793C10.0205 1.28094 9.90627 0.900121 9.63969 0.605851C9.18271 0.100398 8.39337 0 7.27514 0C7.11589 0 6.94625 0 6.76969 0.00692401C6.59313 0.00692401 6.42349 0 6.26424 0C5.14255 0 4.35667 0.100398 3.89969 0.605851C3.63311 0.900121 3.52233 1.28094 3.56387 1.73793C3.58465 1.94218 3.65042 2.11182 3.75082 2.26761V2.49611C3.75082 2.55496 3.69889 2.73152 3.66773 2.84923C3.59157 3.1158 3.4981 3.45162 3.4981 3.80474C3.4981 4.11286 3.56387 4.41406 3.69197 4.7014C3.69197 4.81911 3.69197 4.93682 3.68851 5.05453L3.66773 5.85771C3.64004 6.70936 3.59503 7.45716 3.53618 7.67526C3.24537 8.75195 1.59746 14.7101 1.42089 15.1601C1.19932 15.6586 0.5 19.0099 0.5 22.1014V36.9604C0.5 37.0919 0.531158 37.7774 1.23048 38.4767C2.23793 39.4876 4.08664 40 6.73161 40H6.81123C9.45621 40 11.3084 39.4876 12.3124 38.4767C13.0117 37.7739 13.0428 37.0885 13.0428 36.9638V22.1014C13.0428 19.0133 12.3435 15.6621 12.1254 15.1705Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2371_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5428,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlasFargat);
export default __webpack_public_path__ + "static/media/icon-glas-fargat.4849fa6f10f85fa1219a968acf798d7a.svg";
export { ForwardRef as ReactComponent };